export const getUTMs = url => {
    try {
        
        const params = new URL(url).searchParams;
        const utms = {};
    
        for (const [key, value] of params.entries()) {
            if (key.startsWith('utm_')) {
                const formattedKey = key.charAt(0).toUpperCase() + key.slice(1);
                utms[formattedKey] = value;
            }
        }
    
        return utms;
    } catch (error) {
        console.log(error)
    }
};
